import { createAction } from 'typesafe-actions';
import { KeyComparer, MainResourceHandler, SelectPayload } from './types';

export function createSelectRecordAction<
  TItemKey,
  TItemSummary extends TItemKey,
  TItemBody extends TItemKey,
>(
  displayName: string,
  sameKey: KeyComparer<TItemKey, TItemSummary, TItemBody>,
) {
  const selectRecord = createAction(`@${displayName}/selectRecord`)<
    SelectPayload<TItemKey>
  >();

  const selectRecordHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof selectRecord
  > = (state, action) => {
    const { key } = action.payload;
    const { records } = state;

    const currentRecordIndex = key
      ? records.findIndex(record => sameKey(record.summary, key))
      : undefined;
    if (currentRecordIndex && currentRecordIndex < 0) {
      console.error(
        `could not find key ${key} in ${displayName}.selectHandler`,
        key,
      );
      return state;
    }

    const currentRecord = records[currentRecordIndex!];

    return {
      ...state,
      currentRecordIndex,
      currentRecord,
      currentBody: currentRecord?.body,
    };
  };

  return {
    selectRecord,
    selectRecordHandler,
  };
}
